import { LazyModule } from 'owa-bundling-light';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "ChangeModule"*/ './lazyIndex'),
    { name: 'ChangeModule' }
);
lazyModule.importModule('ChangeModule');

export { moduleToConfigMap } from './configRegistry';
